// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z12g","title":"styles_title__1Ezvi"};